import {vpost} from "@/util/post";

export const miuTeacherService = {
    list(pageSize, pageCurrent, examineStatus, keyword, tagIds = []) {
        let dto = {
            pageSize,
            pageCurrent,
            examine: examineStatus,
            keyword,
            tagIds
        };

        return vpost("/adminMiuTeacherService/list", dto);
    },


    detail(id) {
        return vpost("/adminMiuTeacherService/detail?id=" + id);
    },

    examine(id, code, errMsg = null) {
        let dto = {
            id,
            code,
            errMsg
        }
        return vpost("/adminMiuTeacherService/examine", dto);
    },

    publish(id, publish) {
        let dto = {
            id,
            publish
        };

        return vpost("/adminMiuTeacherService/publish", dto)
    },

    /**
     * 更新标签
     * @param miuTeachProductId
     * @param tagIds
     * @returns {Promise}
     */
    updateMiuTeachProductTag(miuTeachProductId, tagIds) {
        let dto = {
            miuTeachProductId,
            tagIds
        };
        return vpost("/adminMiuTeacherService/updateMiuTeachProductTag", dto);
    },

}
